import React, { useState } from 'react'
import {
  onfsLinkStyle,
  onfsLinkStyleHovered
} from '../../branding/onfsLinkStyles'

export default function OnfsLink({ href, children, style, ...rest }) {
  if (href === '#') {
    throw Error(
      'Use a button with link styling instead. It is not compliant to use anchors with #.'
    )
  }

  const [isHovered, setIsHovered] = useState(false)

  let linkStyle = {
    ...onfsLinkStyle,
    ...style
  }

  if (isHovered) {
    linkStyle = { ...linkStyle, ...onfsLinkStyleHovered }
  } else if (!isHovered) {
    linkStyle = { ...linkStyle }
  }

  return (
    <a
      href={href}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
      style={linkStyle}
    >
      {children}
    </a>
  )
}
